export default __webpack_public_path__ + "static/media/project-wizard-eapp-rules_dark.ea427138.png";